import { render, staticRenderFns } from "./Histogram.vue?vue&type=template&id=e957e2f6&scoped=true"
import script from "./Histogram.vue?vue&type=script&lang=js"
export * from "./Histogram.vue?vue&type=script&lang=js"
import style0 from "./Histogram.vue?vue&type=style&index=0&id=e957e2f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e957e2f6",
  null
  
)

export default component.exports